/* eslint-disable jsx-a11y/prefer-tag-over-role */
import React from "react";
import { Select, SelectItem } from "@clarkinc/zest-design-system/ui";
import { ShippingAddress } from "../Models";
interface Props {
  isDisabled: boolean;
  setShippingId: (val: number) => void;
  shippingAddresses: readonly ShippingAddress[];
  selectedAddressId: number;
  isFreeview?: boolean;
}
const ShippingDropdown = ({
  isDisabled,
  setShippingId,
  shippingAddresses,
  selectedAddressId,
  isFreeview = false
}: Props) => {
  const handleValueChange = (value: string) => {
    const selectedAddress = shippingAddresses.find(address => address.display === value)?.id ?? selectedAddressId;
    setShippingId(selectedAddress);
  };
  return <div className="px-0 py-6 border-0 border-b border-solid border-gray-200" data-sentry-component="ShippingDropdown" data-sentry-source-file="ShippingDropdown.tsx">
      <div className="lm:flex lm:flex-col">
        <span id="plus-modal-shipping-heading" className="w-auto text-base font-bold text-gray-800">
          Select Shipping Address
        </span>
        <p id="plus-modal-shipping-information" className="pb-2 mb-0 text-xs font-normal text-gray-800">
          {isFreeview ? <>
              Once you are subscribed to Plus you can add additional addresses
              via your account for $49/month.
            </> : <>Your subscription is only valid for a single shipping address.</>}
        </p>
        <div className="relative" data-dropdown-type="select">
          <Select label="Payment Method" hideLabel inputSize="large" placeholder="Select an option" disabled={isDisabled} onValueChange={value => handleValueChange(value)} value={shippingAddresses.find(address => address.id === selectedAddressId)?.display} data-sentry-element="Select" data-sentry-source-file="ShippingDropdown.tsx">
            {shippingAddresses.map(address => <SelectItem value={address.display} key={address.id} onClick={() => {
            setShippingId(address.id);
          }}>
                <span className="leading-7">{address.display}</span>
              </SelectItem>)}
          </Select>
        </div>
      </div>
    </div>;
};
export default ShippingDropdown;